module.exports = __webpack_public_path__ + "static/img/honorPlay4Pro.c3657c6d.png";